<template>
  <error-page-layout
    icon="cancel"
    error-type="Erro 500"
    color-type="error"
    title="Algo deu errado"
    first-message="Ocorreu um erro inesperado em nosso servidor."
    second-message="Acompanhe a resolução desse problema com o "
    focus-message="protocolo de atendimento:"
    under-message="0ZOL7893754"
    image-name="500.png"
  >
    <div slot="buttons">
      <mf-button label="Voltar para a home" text color="orange" />
      <mf-button label="Acompanhar chamado" text color="orange" />
    </div>
  </error-page-layout>
</template>

<script>
import ErrorPageLayout from '@/components/ErrorPageLayout.vue'
export default {
  components: {
    ErrorPageLayout,
  },
}
</script>
